// src/composables/useIconStyle.js
import { computed, defineProps } from "vue";

export const props = () => {
  defineProps({
    ignoreDefaultStyle: { type: Boolean, default: false },
    color: { type: String, default: "#000000" },
    width: { type: String, default: "20px" },
    height: { type: String, default: "20px" },
  });
};

export function useIconStyle() {
  const style = computed(() => {
    return props.ignoreDefaultStyle
      ? `fill: ${props.color}; width: ${props.width}; height: ${props.height};`
      : "";
  });

  return {
    style,
  };
}
